import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../../lib/loopback'

const listaAvisoRepository = createRepository({
  path: 'lista-avisos',
  restApi,
  queryTransform: {
    cpfCnpj: query.likeDigits('cpfCnpj'),
    descricao: query.ilike('descricao'),
    ...paginate
  }
})
export default listaAvisoRepository
